import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
    providedIn: 'root',
})
export class SubdomainResolver {
    constructor(@Inject(DOCUMENT) private document: Document) {
    }

    /**
     * Labels die nooit een organisatie aanduiden. Zonder deze lijst wordt www.ares.sale
     * gelezen als de organisatie "www": de landingspagina wordt dan overgeslagen en de
     * app zoekt een niet-bestaande organisatie op.
     */
    private static readonly RESERVED = new Set(['www']);

    resolve(): string | null {
        const hostname = this.document.location.hostname;
        const parts = hostname.split('.');

        // Lokaal ontwikkelen: localhost is het rootdomein, demo.localhost is een tenant.
        // Zonder deze tak valt demo.localhost onder `parts.length <= 2` en zou het als
        // rootdomein gelden, waardoor lokaal de marketingpagina verschijnt in plaats van de app.
        if (hostname === 'localhost' || hostname === '127.0.0.1') {
            return null;
        }
        if (hostname.endsWith('.localhost')) {
            const label = parts[0];
            return SubdomainResolver.RESERVED.has(label) ? null : label;
        }

        // If hostname is just domain.tld (2 parts), it's the root domain
        // Example: ares.sale
        if (parts.length <= 2) {
            return null;
        }

        // If hostname is subdomain.domain.tld (3+ parts), return the subdomain
        // Example: demo.ares.sale -> "demo"
        const subdomain = parts[0];
        return SubdomainResolver.RESERVED.has(subdomain) ? null : subdomain;
    }

}
